<template>
  <div class="footer">
    <container class="footer__inner">
      <div class="footer__credits">

        <p class="text text-solid">
          Над проектом работали:
        </p>

        <ul class="footer__persons">
          <li style="margin-bottom: 14px">
            <p class="text" style="margin-bottom: 4px;">Наталия Ставрогина,</p>
            <p class="subtext">директор по спецпроектам</p>
          </li>
          <li style="margin-bottom: 14px">
            <p class="text" style="margin-bottom: 4px;">Анастасия Геворгян,</p>
            <p class="subtext">менеджер по спецпроектам</p>
          </li>
          <li style="margin-bottom: 14px">
            <p class="text" style="margin-bottom: 4px;">Юлия Чижикова,</p>
            <p class="subtext" v-html="`руководитель направления по работе с&nbsp;рекламными агентствами`"></p>
          </li>
        </ul>

        <div class="footer__dev">
          <DevCredit></DevCredit>
        </div>
      </div>
      <div class="footer__socials">
        <Likes></Likes>
      </div>

      <div class="footer__contact">
        <p class="text">
          По вопросам сотрудничества:
          <a href="mailto:special@vedomosti.ru" class="link link--underline text-solid">special@vedomosti.ru</a>
        </p>
      </div>
    </container>
  </div>
</template>

<script>
  import Likes from '@/components/Likes.vue'
  import DevCredit from '@/components/DevCreit.vue'

  export default {
    components: { Likes, DevCredit }
  }
</script>

<style lang="scss">
  .footer {
    background: $color-navy;
    @include more(scale) {
      padding: 60px 0 105px;
    }
    @include less(tablet) {
      padding: 30px 0;
    }
  }

  .footer__inner {
    display: flex;

    @include more(scale) {
      justify-content: space-between;
      & > * {
        flex: 0 0 auto;
        width: 250px;
      }
    }
    @include less(tablet) {
      flex-direction: column;
      max-width: 480px
    }
  }

  .footer__credits {
    @include less(tablet) {
      order: 5
    }
  }

  .footer__dev {
    margin-top: 20px;
  }

  .footer__socials {
    @include more(scale) {
      text-align: center;
    }
    @include less(tablet) {
      order: 0;
      margin-bottom: 25px;
    }
  }

  .footer__contact {
    @include less(tablet) {
      order: 1;
      margin-bottom: 25px;
    }
  }
</style>
